"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeedbackProvider = exports.FeedbackContext = exports.useFeedback = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var feedback_dialog_1 = __importDefault(require("./feedback-dialog"));
var defaultFeedbackContext = {
    isFeedbackDialogOpen: false,
    setIsFeedbackDialogOpen: function () { },
    feedbackComponent: (0, jsx_runtime_1.jsx)(feedback_dialog_1.default, {}),
    location: '',
};
var useFeedback = function () {
    var context = react_1.default.useContext(exports.FeedbackContext);
    return context;
};
exports.useFeedback = useFeedback;
exports.FeedbackContext = react_1.default.createContext(defaultFeedbackContext);
var FeedbackProvider = function (_a) {
    var children = _a.children;
    var _b = react_1.default.useState(false), isFeedbackDialogOpen = _b[0], setIsFeedbackDialogOpen = _b[1];
    var _c = react_1.default.useState('navigation'), location = _c[0], setLocation = _c[1];
    return ((0, jsx_runtime_1.jsx)(exports.FeedbackContext.Provider, { value: {
            isFeedbackDialogOpen: isFeedbackDialogOpen,
            setIsFeedbackDialogOpen: function (value, location) {
                location && setLocation(location);
                setIsFeedbackDialogOpen(value);
            },
            feedbackComponent: (0, jsx_runtime_1.jsx)(feedback_dialog_1.default, {}),
            location: location,
        }, children: children }));
};
exports.FeedbackProvider = FeedbackProvider;
